/**
 * Bug #489
 * @Author Anupama P
 * @Date 9 Jul 2021
 */
import { BreadCrumb, Col, StickyBox } from 'components'
import DoctorSidebar from 'client/components/doctors/sidebar'

function DoctorSidebarSub() {
    return (
        <Col
        md={12}
        lg={4}
        xl={3}
        className="theiaStickySidebar"
      >
        <StickyBox offsetTop={20} offsetBottom={20}>
          <DoctorSidebar />
        </StickyBox>
      </Col>
    )
}
export default DoctorSidebarSub
/** End */